import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import getUrl from 'front-end-core/core/url'
import Route from 'route-parser'
import { PRECEDENTS_CONTENT, PRECEDENTS_AUTOMATED_LISTINGS } from 'constants/controllers'
import { URL_DOC_DRAFTER_DOCUMENT_INTERVIEW } from 'constants/urls'
import { dismissPopover } from 'services/OverlayService'
import selectAolName from 'redux/selectors/selectAolName'
import selectIsLogged from 'redux/selectors/selectIsLogged'
import { setSignUpModalIsOpen } from 'redux/actions'
import Xml from 'components/shared/Xml'

const SsoRoute = new Route(URL_DOC_DRAFTER_DOCUMENT_INTERVIEW)

const PrecedentResultsItem = ({
  parentTitle,
  sectionId,
  sectionTitle,
  description,
  id,
  library,
  name,
  title,
  parentId
}) => {
  const dispatch = useDispatch()
  const isValidResult = parentTitle !== null && sectionId !== null && sectionTitle !== null

  if (!title && !name) { return null }
  if (!isValidResult) { return <CorruptData {...{ name, title }} /> }

  const aol = useSelector(selectAolName)
  const isLogged = useSelector(selectIsLogged)
  const isAutomated = library === 'automated docs'

  const precedentUrl = isAutomated
    ? SsoRoute.reverse({ uuid: id, aol })
    : getUrl(PRECEDENTS_CONTENT, {
      aol,
      view: library === 'precedents' ? 'browse' : library,
      sectionId,
      precedentId: id
    })
  // Exclude description if empty without tags: eg. <p><br /><p>
  const checkedDescription = description
    ? description.replace(/(<([^>]+)>)/ig, '').length
      ? description
      : null
    : null

  const handleClick = (e) => {
    dismissPopover(e.target)
    if (isLogged || !isAutomated) {
      return
    }

    dispatch(setSignUpModalIsOpen(true))
    e.preventDefault()
    e.stopPropagation()
  }

  return (
    <li className='mt7 mb3'>
      <h2 className='ma0 lh-copy f5 fw6'>
        <a
          href={precedentUrl}
          onClick={handleClick}
          className='black no-underline hover-cadet-blue'
          {...{
            target: isAutomated ? '_blank' : null,
            rel: isAutomated ? 'noopener noreferrer' : null
          }}
        >
          <span>
            <Xml render={title || name} />
          </span>
        </a>
      </h2>
      <Path {...{ library, sectionId, sectionTitle, parentId, parentTitle }} />
      <div className='f5 lh-copy black' dangerouslySetInnerHTML={{ __html: checkedDescription }} />
    </li>
  )
}

const CorruptData = ({ name, title }) => (
  <li className='mt7 mb3'>
    <h2 className='ma0 lh-copy f5 fw6'>
      <span className='fc-search-result-question'>
        <Xml render={title || name} />
      </span>
    </h2>
    <ul className='list-reset pl0 mt2 mb3 pseudo-arrows'>
      <li className='tomato f7 di'>
        Not available
      </li>
    </ul>
    <div />
  </li>
)

const Path = ({ library, sectionId, sectionTitle, parentId, parentTitle }) => {
  const aol = useSelector(selectAolName)

  const defaultView = 'browse'
  const isPrecedents = library === 'precedents'

  const view = isPrecedents ? defaultView : 'precedents-automated'
  const controller = isPrecedents ? PRECEDENTS_CONTENT : PRECEDENTS_AUTOMATED_LISTINGS // library could be one of these -> automated docs,precedents

  return (
    <ul className='list-reset pl0 mt2 mb3 pseudo-arrows'>
      <li className='cadet-blue f7 di'>
        <a
          className='cadet-blue no-underline hover-underline'
          href={getUrl(PRECEDENTS_CONTENT, { aol, view: defaultView })}
        >
          Documents
        </a>
      </li>
      <li className='cadet-blue f7 di'>
        <a
          className='cadet-blue no-underline hover-underline'
          href={getUrl(controller, { aol, view, sectionId })}
        >
          {sectionTitle}
        </a>
      </li>
      <li className='cadet-blue f7 di'>
        <a
          className='cadet-blue no-underline hover-underline'
          href={getUrl(controller, { aol, view, sectionId, [isPrecedents ? 'expanded' : 'focusedId']: parentId })}
        >
          {parentTitle}
        </a>
      </li>
    </ul>
  )
}

export default PrecedentResultsItem
